<template>
    <alert-modal
        :title="modalHeading"
        :superTitle="modalSuperHeading"
        :primaryCTAText="$t('ACTION_OKAY')"
        @close="close"
        @confirm="close"
        class="cz2__attach-packs-info"
    >
        <div class="cz2__modal-popup__copy">
            {{ modalCopy }}
        </div>

        <custom-swiper
            :show-mask="false"
            :space-between="0"
            :has-mobile-bullets="true"
        >
            <template v-slot:slides>
                <img
                    v-for="pack in packs"
                    :key="pack.code"
                    :src="pack.image"
                    :alt="pack.component.description[0].name"
                    height="219"
                    width="auto"
                    class="swiper-slide"
                >
            </template>
        </custom-swiper>

        <p v-if="canBuyPop" class="cz2__modal-popup__copy cz2__attach-packs-price">
            {{ price }} {{ $t('EACH') }}
        </p>
    </alert-modal>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__attach-packs-info {
            .cz2__attach-packs-price,
            .cz2__modal-popup__copy {
                color: #040504;
                font-family: 'Open Sans', sans-serif;
                line-height: 20px;
            }

            .cz2__attach-packs-price {
                margin: 8px 0 16px 0;

                @include font(h1);
                font-size: 24px;

                text-transform: uppercase;
            }

            .cz2__btn--black,
            .cz2__btn--black:hover {
                height: 60px;
                font-size: 22px;
            }
        }
    }
</style>

<script>
    import AlertModal from './ui/AlertModal.vue';
    import CustomSwiper from './ui/CustomSwiper.vue';

    import { formatPrice } from '../helpers/formatPrice';

    export default {
        components: {
            AlertModal,
            CustomSwiper,
        },

        computed: {
            options() {
                return this.$store.state.customizer.options;
            },

            canBuyPop() {
                return this.options && this.options.canBuyPop;
            },

            customAttributes() {
                return this.$store.state.customizer.viewController.blueprint.custom;
            },

            modalHeading() {
                return this.customAttributes['attach-pack-modal-heading'];
            },

            modalSuperHeading() {
                return this.customAttributes['attach-pack-modal-super-heading'] || this.$t('DONT_MISS_OUT');
            },

            modalCopy() {
                return this.customAttributes['attach-pack-modal-copy'];
            },

            packs() {
                return this.$store.getters.attachPacks;
            },

            price() {
                return formatPrice(this.$store.state, this.packs[0].price, 'compact');
            },
        },

        methods: {
            close() {
                this.$store.dispatch('showAttachPackInfoModal', false);
            },
        },
    };
</script>
